"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorTag = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var TagBase_1 = require("../TagBase");
exports.ColorTag = function (_a) {
    var color = _a.color, props = tslib_1.__rest(_a, ["color"]);
    return (react_1.default.createElement(StyledTag, tslib_1.__assign({ color: color, icon: "media_record" }, props)));
};
var StyledTag = styled_components_1.default(function (_a) {
    var color = _a.color, props = tslib_1.__rest(_a, ["color"]);
    return (react_1.default.createElement(TagBase_1.TagBase, tslib_1.__assign({ classes: { deleteIcon: 'deleteIcon' } }, props)));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    background-color: white;\n    color: ", ";\n    border: solid 1px #eaeaea;\n\n    > i:first-of-type {\n      color: ", ";\n    }\n\n    .deleteIcon {\n      color: ", ";\n    }\n  }\n"], ["\n  && {\n    background-color: white;\n    color: ", ";\n    border: solid 1px #eaeaea;\n\n    > i:first-of-type {\n      color: ", ";\n    }\n\n    .deleteIcon {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
});
var templateObject_1;
